import { InjectionToken } from '@angular/core';
import { IUserService } from '../interfaces/user-service';

export const USER_SERVICE = new InjectionToken<IUserService>('USER_SERVICE');
